import { useEffect, useState } from "react";
import useCreateTrip from "../../components/CommonComponents/CreateTrip/useCreateTrip";
import { ERROR_MESSAGES } from "../../constants/errorMessages";
import { addToBag, clearBag, fetchBagProducts } from "../../store/reducers/bag/apiThunk";
import { useDispatch } from "react-redux";
import { useShoppingCart } from "../../context/ShoppingCartContext";

export function useAddToCart(showCreateTrip, isDiscardModalOpen, productDetails, reset) {
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [error, setError] = useState("");
  const [outOfStock, setOutOfStock] = useState(false);
  const [discardTripLoader, setDiscardTripLoader] = useState(false);
  const [addtoCartLaoding, setLoading] = useState(false);
  const quantity = 1
  const dispatch = useDispatch();
   const { selectedProduct, setDiscardModalOpen, openModal, setBagItems, setBagItemsLoader, setTripDetails, tripDetails } = useShoppingCart();
  const { selectedTrip, setSelectedTrip, loadingTripDetails } = useCreateTrip(showCreateTrip, isDiscardModalOpen, setTripDetails)
  
  const onAddToCart = () => {
  let errorKey = "";

  switch (true) {
    case !selectedTrip && !(tripDetails?.hotel_name?.length && tripDetails?.city_name.length && tripDetails?.arrival_date?.length) &&  !selectedSize:
      errorKey = "NO_TRIP_NO_SIZE";
      break;
    case !selectedTrip && !selectedSize:
      errorKey = "NO_SELECTED_TRIP_NO_SIZE";
      break;
    case !tripDetails?.id && !selectedSize:
      errorKey = "NO_TRIP_NO_SIZE";
      break;
    case !tripDetails?.id:
      errorKey = "NO_TRIP";
      break;
    case !selectedTrip:
      errorKey = "NO_SELECTED_TRIP";
      break;
    case !selectedSize:
      errorKey = "NO_SIZE";
      break;
    case !selectedColor:
      errorKey = "NO_COLOR";
      break;
    default:{
      errorKey = "";
      addProductToBag()
      }
    }

    setError(errorKey ? ERROR_MESSAGES[errorKey] : "");
  };

  const addProductToBag = async () => {
    setLoading(true);
    const data = {
      "trip": tripDetails?.id,
        "product_id": productDetails?.id,
        "size": selectedSize,
        "color": selectedColor,
        "quantity": quantity
    }
    const guestUserSessionKey = localStorage.getItem("guestUserSessionKey");
    let dataToSend;
    if(guestUserSessionKey) {
      dataToSend = {
        ...data,
        session_id: guestUserSessionKey
      }
    } else {
      dataToSend = data
    }

    try {
        await dispatch(addToBag(dataToSend)).then((resp)=>{
          if(resp?.payload?.status)
            getCartDetails()
          else 
            setLoading(false)
        })
    } catch (error) {
        console.error("Error setting favourite product:", error);
        setLoading(false)
    } 
  }

  const getCartDetails = () => {
    setBagItemsLoader(true)
    dispatch(fetchBagProducts()).then((response)=>{
      setBagItems(response?.payload?.data)
      setLoading(false)
    }).finally(()=>{
      setBagItemsLoader(false)
    }
    )
  }


  const discardBag = async (tripId) => {
    setDiscardTripLoader(true)
    try {
      const response = await dispatch(clearBag(tripId))

      if(selectedProduct && response?.payload?.status){
        reset()
        setDiscardModalOpen(false)
        setBagItems([])
      } else if(!selectedProduct && response?.payload?.status) {
        reset()
        openModal(null, null)
        setBagItems([])
      }
    } catch (error) {
        console.error("Error removing trip:", error);
    } finally {
      setDiscardTripLoader(false)
    }
  }

  useEffect(() => {
    setError("");
  }, [selectedSize, selectedTrip]);

  useEffect(()=>{
    getCartDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return {
    selectedSize,
    setSelectedSize,
    selectedColor,
    setSelectedColor,
    setError,
    error,
    onAddToCart,
    outOfStock,
    setOutOfStock,
    tripDetails,
    selectedTrip,
    setSelectedTrip,
    loadingTripDetails,
    discardBag,
    discardTripLoader,
    getCartDetails,
    addtoCartLaoding
  };
}
